import * as styles from './styles/styles.module.scss';
import SeoTabCard from './SeoTabCard';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import chunks from '../../../../utils/chunks';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { defineMessages } from 'react-intl';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';

const SEO_TABBED_CONTENT_STRINGS = defineMessages({
  TRAIL: {
    defaultMessage: 'Trail'
  },
  TRAILS: {
    defaultMessage: 'Trails'
  }
});

export type Card = {
  distance?: number;
  imgSrc: string;
  time?: number;
  title: string;
  url: string;
  numberOfTrails?: number;
};

type Props = {
  cards: Card[];
  languageRegionCode: LanguageRegionCode;
  displayMetric: boolean;
};

const SeoTabbedContent = ({ cards = [], languageRegionCode, displayMetric }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { TRAIL, TRAILS }
  } = useFormatMessage(SEO_TABBED_CONTENT_STRINGS);

  const getDistanceAndTimeString = ({ distance, time }: { distance?: number; time?: number }): string => {
    const formattedDistance = MapStatsUtil.metersToFormattedUserUnits(distance, 1, displayMetric, languageRegionCode);
    const formattedTime = MapStatsUtil.minutesToFormattedTime(time);
    let label = `${formattedDistance}`;

    if (formattedTime) {
      label += ` • ${formattedTime}`;
    }

    return label;
  };

  const getNumberOfTrailString = (trailNum: number): string => {
    const trailString = trailNum === 1 ? TRAIL : TRAILS;

    return `${MapStatsUtil.formatData(trailNum, 0, null, languageRegionCode)} ${trailString}`;
  };

  const cardProps = (card: Card) => {
    const subtext = card.numberOfTrails ? getNumberOfTrailString(card.numberOfTrails) : getDistanceAndTimeString(card);

    return {
      subtext,
      title: card.title,
      imgSrc: card.imgSrc,
      url: LanguageSupportUtil.wrapUrlSafe(`${card.url}?ref=homepage_seotabbed`, languageRegionCode)
    };
  };

  const chunkedCards = [
    ...chunks(
      cards.filter(card => card.title),
      4
    )
  ];

  return (
    <div className={styles.container}>
      {chunkedCards.map(cardRows => {
        return (
          <div key={cardRows[0].title}>
            {cardRows.map((card: Card) => (
              <SeoTabCard {...cardProps(card)} key={card.title} />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SeoTabbedContent;
